module.exports = __webpack_public_path__ + "img/sunrise.1f77e8a7.svg";